export default __webpack_public_path__ + "static/media/WellsFargo.9199893b.svg";